import { ToastPosition, ToastType } from '@hotmart/space-lib-events/dist/toast/enum'
import { toastEventDispatch } from '@hotmart/space-lib-events/dist/toast'
import i18n from 'src/i18n'
import { queryClient } from 'src/config/request'
import useBlockCommentsMutation from '../useBlockCommentsMutation/useBlockCommentsMutation'
import { BlockCommentsMutationProps } from '../useBlockCommentsMutation/useBlockCommentsMutation.types'
import { BlockCommentsLabels, UnblockCommentsLabels } from '../../blockCommentsModal.constants'

const useBlockComments = (onClose: () => void) => {
  const {
    blockCommentsMutation: { mutate, isLoading }
  } = useBlockCommentsMutation()

  const invalidateGetPostsQuery = () => {
    queryClient.invalidateQueries({
      queryKey: ['getPosts']
    })

    queryClient.invalidateQueries({
      queryKey: ['getPinnedPosts']
    })
  }

  const onConfirmButton = ({ postId, isCommentsEnabled }: BlockCommentsMutationProps) => {
    const { errorToast, successToast } = isCommentsEnabled
      ? BlockCommentsLabels
      : UnblockCommentsLabels

    mutate(
      { postId, isCommentsEnabled },
      {
        onSuccess: /* istanbul ignore next */ () => {
          invalidateGetPostsQuery()

          toastEventDispatch({
            type: ToastType.SUCCESS,
            message: i18n.t(successToast),
            position: ToastPosition.BOTTOM_RIGHT
          })

          onClose()
        },
        onError: /* istanbul ignore next */ () => {
          toastEventDispatch({
            type: ToastType.DANGER,
            message: i18n.t(errorToast),
            position: ToastPosition.BOTTOM_RIGHT
          })
        }
      }
    )
  }

  return { onConfirmButton, isLoading }
}

export default useBlockComments
